import superagent from 'superagent';
import { JWT_TOKEN } from '../constants';
const methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? '/' + path : path;
  return adjustedPath;
}

export default class ApiClient {
  constructor(history) {
    methods.forEach((method) =>
      this[method] = (path, { params, data } = {}) => new Promise((resolve, reject) => {
        const request = superagent[method](path);
        const token = localStorage.getItem(JWT_TOKEN);

        request.set('Authorization', `Bearer ${token}`);
        // console.log('request', request);
        if (params) {
          request.query(params);
        }

        if (data) {
          request.send(data);
        }

        request.end((err, res = {}) => {          
          if (res.unauthorized) {
            history.push('/login');
          }

          return err ? reject(res.body || err) : resolve(res.body);
        });
      }));
  }
  empty() {}
}